import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'TaskReceiver'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetTaskRescourseTeamList',
    'GetTaskMaterialsList',
    'GetTaskShelterList',
    'GetTaskTranResourcesList',
    'GetTaskCommunicationResourcesList',
    'GetTaskMedicalresourcesList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const PlantaskreceiverApi = ZJApi.defineNewApi('PlantaskreceiverApi', factory);

export default PlantaskreceiverApi;